export type LessonGroupExamEntryRef =
  | { source: "module_exam"; moduleExamId: number }
  | { source: "lesson_student_exam"; lessonId: number; examId: number }

export function parseLessonGroupExamEntryId(
  entryId: string,
): LessonGroupExamEntryRef {
  const moduleExamMatch = entryId.match(/^module_exam:(\d+)$/)
  if (moduleExamMatch) {
    return { source: "module_exam", moduleExamId: Number(moduleExamMatch[1]) }
  }

  const lessonExamMatch = entryId.match(/^lesson:(\d+):exam:(\d+)$/)
  if (lessonExamMatch) {
    return {
      source: "lesson_student_exam",
      lessonId: Number(lessonExamMatch[1]),
      examId: Number(lessonExamMatch[2]),
    }
  }

  throw new Error(`Invalid lesson group exam entry id: ${entryId}`)
}
